// extracted by mini-css-extract-plugin
module.exports = {"ManualsResults":"ManualsResults_ManualsResults__Mb5nV","ManualsResultsItems":"ManualsResults_ManualsResultsItems__3W-jO"};